module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/eg57hQ/tc-custom/9781488069628.jpg?1708085012634",
      "alt": "This image is the cover for the book Texan Tries Again, Men of the West"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texan Tries Again, Men of the West\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author, a widower starts over in small Arizona town and gets a second chance at love with a local waitress.")]), _c('br'), _c('br'), _vm._v("This cowboy is trying to put the past behind him . . . "), _c('br'), _c('br'), _vm._v("A new start in Arizona . . . Could give this Texan a second chance"), _c('br'), _c('br'), _vm._v("After losing everything, Taggart O’Brien is more than happy to take an offer to be the foreman at Three Rivers Ranch. But once he meets Emily-Ann Broadmoor, he’s not ready for any of the feelings she arouses. He’d promised he’d never put his heart on the line again—until Emily-Ann makes him think about a different kind of promise . . . "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stella Bagwell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0